// ProgressRail — presentational. The step tracker across the top; clicking a
// past/current step jumps to it (future steps are disabled).
export function ProgressRail({
  steps,
  current,
  onJump,
}: {
  steps: Array<{ name: string; sub: string }>
  current: number
  onJump: (step: number) => void
}) {
  const total = String(steps.length).padStart(2, '0')
  return (
    <div className="progress-rail">
      {steps.map((s, idx) => {
        const pos = idx + 1
        const state = pos < current ? 'done' : pos === current ? 'current' : 'upcoming'
        return (
          <button
            key={s.name}
            type="button"
            className={`progress-step ${state}`}
            onClick={() => onJump(pos)}
            disabled={pos > current}
          >
            <span className={`progress-circle ${state}`}>
              {state === 'upcoming' || state === 'current' ? pos : ''}
            </span>
            <span className="progress-label">
              <span className="name">{s.name}</span>
              <span className="sub">{s.sub}</span>
            </span>
          </button>
        )
      })}
      <div className="progress-counter">
        Step <b>{String(current).padStart(2, '0')}</b> of {total}
      </div>
    </div>
  )
}
